import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import { z } from 'zod';
import { type ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';

export const classPasswordShape = z.object({
  id: z.string(),
  user_id: z.string(),
  class_password: z.string(),
});

export type ClassPassword = z.infer<typeof classPasswordShape>;

async function getClassPasswordApi(): Promise<ClassPassword> {
  const classPassword = await fetcher('/class-passwords', {
    service: '/roster',
    version: '/v1',
  });

  return classPasswordShape.parse(classPassword);
}

export const getClassPasswordApiQueryKey = () => {
  return ['/v1', 'class-passwords'].filter(Boolean);
};

export function useGetClassPasswordApi(
  customQueryOptions?: Omit<
    UseQueryOptions<ClassPassword, ApiError>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<ClassPassword, ApiError> {
  return useQuery({
    queryKey: getClassPasswordApiQueryKey(),
    queryFn: () => getClassPasswordApi(),
    ...customQueryOptions,
  });
}
